var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0003 1.66675C5.40033 1.66675 1.66699 5.40008 1.66699 10.0001C1.66699 14.6001 5.40033 18.3334 10.0003 18.3334C14.6003 18.3334 18.3337 14.6001 18.3337 10.0001C18.3337 5.40008 14.6003 1.66675 10.0003 1.66675ZM12.942 10.0251C12.817 10.1501 12.6587 10.2084 12.5003 10.2084C12.342 10.2084 12.1837 10.1501 12.0587 10.0251L10.6253 8.59175V12.9167C10.6253 13.2584 10.342 13.5417 10.0003 13.5417C9.65866 13.5417 9.37533 13.2584 9.37533 12.9167V8.59175L7.94199 10.0251C7.70033 10.2667 7.30033 10.2667 7.05866 10.0251C6.81699 9.78341 6.81699 9.38342 7.05866 9.14175L9.55866 6.64175C9.80033 6.40008 10.2003 6.40008 10.442 6.64175L12.942 9.14175C13.1837 9.38342 13.1837 9.78341 12.942 10.0251Z",
    fill: "#4D4F56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow-up.a5bb8c1216c9fc734b12c7084e1005c8.svg";
export { ForwardRef as ReactComponent };